export const colors: Record<string, string> = {
  'faststart': '#1d4588',
  'basecamp': '#ffcc00',
  'activate': '#015851',
  'accelerate': '#46c3b2',
  'advance': '#0083eb',
}

export const labels: Record<string, string> = {
  'faststart': 'Fast Start',
  'basecamp': 'Base Camp',
  'activate': 'Activate',
  'accelerate': 'Accelerate',
  'advance': 'Advance',
}

export const phases = Object.keys(colors)
